import { render, staticRenderFns } from "./ShippingLogBLPop.vue?vue&type=template&id=34f8cfc2"
import script from "./ShippingLogBLPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogBLPop.vue?vue&type=script&lang=js"
import style0 from "./ShippingLogBLPop.vue?vue&type=style&index=0&id=34f8cfc2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f8cfc2')) {
      api.createRecord('34f8cfc2', component.options)
    } else {
      api.reload('34f8cfc2', component.options)
    }
    module.hot.accept("./ShippingLogBLPop.vue?vue&type=template&id=34f8cfc2", function () {
      api.rerender('34f8cfc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogBLPop.vue"
export default component.exports